import React, { useContext } from 'react';
import { StyledButtonGroup } from '../SubPageNavigationStyles';
import { CtaPrimary, CtaSecondary } from './CallToAction';
import { Context } from '../../../context/Context';
import VtpPopover from './VtpPopOver';

const CtaSection = () => {
  const {
    content: { cta, secondaryCta },
    renderPrimaryButton,
    renderVtpButtons,
    renderSecondaryButton,
  } = useContext(Context);

  return (
    <StyledButtonGroup>
      {renderPrimaryButton && <CtaPrimary {...cta[0]} />}
      {renderVtpButtons && <VtpPopover disabled={false} />}
      {renderSecondaryButton && <CtaSecondary {...secondaryCta.customCta} />}
    </StyledButtonGroup>
  );
};

export default CtaSection;
